{
	"title": "История на транзакциите за {{productName}}",
	"item": {
		"time": "Време",
		"description": "Описание",
		"transactionId": "ID на транзакция",
		"showIds": "Покажи ID-та",
		"depositTitle": "Уверение от DNV, позволяващо депозит във въглеродната банка",
		"depositDescription": "След като независимият орган за уверение „DNV“ потвърди обема на съхранения уловен въглерод в цифрова система Monitor-Report-Verify, се извършва нов депозит във въглеродната банка.",
		"withdrawalTitle": "Фактура към доставчик, задействаща теглене от въглеродната банка",
		"withdrawalDescription": "При фактурирането на материал evoZero към доставчика се извършва теглене от въглеродната банка.",
		"transferTitle": "Прехвърляне на въглеродни редукции към притежателя на декларацията",
		"transferDescription": "Доставчикът инициира прехвърлянето на въглеродните редукции към притежателя на декларацията въз основа на обема материал evoZero, вложен в доставения продукт."
	},
	"proofIdsModal": {
		"titleTransactions": "Преглед на транзакции",
		"titleMeasurements": "Преглед на измервания",
		"paragraph1": "Една стъпка от транзакционния процес в {{productName}} включва агрегиране на транзакции в разпределен регистър. По-долу ще намерите списък с връзки към услуги на трети страни, където можете да прегледате тези транзакции.",
		"paragraph2": "Имайте предвид, че тези връзки ще ви отведат към външни уебсайтове, които предоставят възможности за преглед на транзакции.",
		"open": "Отвори",
		"close": "Затвори"
	},
	"errors": {
		"fetch": "Не можа да се зареди историята на активността"
	}
}
